import { useCallback } from 'react';
import { Step, Workflow } from './Workflow';
import useFeature from 'hooks/useFeature';
import { FeatureGroups } from 'state/tenant';
import useResponsiveQuery from 'hooks/useResponsiveQuery';
import useQueryParameters from 'hooks/useQueryParameters';
import { keys, not, reject } from 'ramda';

const useMembershipValidationWorkflow = () => {
  const { isGroupEnabled } = useFeature();
  const { isMobile } = useResponsiveQuery();
  const { selectedCardKey } = useQueryParameters();
  const { isEnabled } = useFeature();
  const getWorkflow = useCallback((): Workflow => {
    const stepsEnabled = {
      [Step.CARD_SELECTOR]: isEnabled('cardSelector') && !selectedCardKey,

      [Step.MEMBERSHIP_VALIDATION]: true,

      [Step.APPLICATION]: true,

      [Step.APPLICATION_2]: isMobile,

      [Step.ADD_ONS]: isGroupEnabled(FeatureGroups['add-ons']),

      [Step.REVIEW_TERMS]: true,
    };
    const firstStep = ((keys(
      reject(not, stepsEnabled),
    ) as unknown) as Step[])[0];
    return {
      stepsEnabled: stepsEnabled,
      paths: {
        [Step.CARD_SELECTOR]: '/card-selector',
        [Step.MEMBERSHIP_VALIDATION]: '/membership-validation-start',
        [Step.APPLICATION]: '/credit-application',
        [Step.APPLICATION_2]: '/credit-application/2',
        [Step.ADD_ONS]: '/add-ons',
        [Step.REVIEW_TERMS]: '/review-terms',
        ...{
          [firstStep]: '/membership-validation',
        },
      },

      progressStartStep: Step.APPLICATION,
      restartStep: Step.MEMBERSHIP_VALIDATION,
      timeoutRestartPath: '/membership-validation',
    };
  }, [isEnabled, isGroupEnabled, isMobile, selectedCardKey]);

  return getWorkflow;
};

export default useMembershipValidationWorkflow;
